import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CokieLawComponent } from './cookie-law.component';

import { CookieLawService } from './cookie-law.service';
import { SacyrModalModule } from '../sacyr-modal/sacyr-modal.module';

@NgModule({
  declarations: [
    CokieLawComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    SacyrModalModule,
  ],
  exports: [
    CokieLawComponent
  ],
  providers: [
    CookieLawService
  ]
})

export class CookieLawModule { }